import React, { useState, memo } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function TourDescription() {
  const [expanded, setExpanded] = useState(false);
  return <section className="py-8" data-id="element-1548">
      <div className="container mx-auto px-4" data-id="element-1549">
        <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1550">
          Tour Description
        </h2>
        <div className={`relative overflow-hidden ${expanded ? '' : 'max-h-[200px]'}`} data-id="element-1551">
          <div className="prose max-w-none text-gray-700" data-id="element-1552">
            <p className="mb-4" data-id="element-1553">
              Experience the magic of Santorini with our exclusive Sunset & Wine
              Tasting Tour. This 8-hour adventure combines the island's most
              iconic views with its celebrated winemaking tradition for an
              unforgettable day in the Aegean.
            </p>
            <p className="mb-4" data-id="element-1554">
              Your journey begins with a convenient hotel pickup as we transport
              you to the picturesque village of Oia, famous for its blue-domed
              churches and whitewashed buildings cascading down the caldera
              cliffs. Explore the charming streets at your leisure, discovering
              local artisan shops and breathtaking viewpoints.
            </p>
            <p className="mb-4" data-id="element-1555">
              Next, we'll visit one of Santorini's renowned wineries, where
              you'll learn about the island's unique viticulture. The volcanic
              soil and traditional "kouloura" vine-growing technique produce
              distinctive wines with exceptional minerality. Enjoy a guided
              tasting of 4 premium local varieties, including the crisp
              Assyrtiko and the sweet Vinsanto, complemented by a platter of
              Greek delicacies.
            </p>
            <p className="mb-4" data-id="element-1556">
              As the day draws to a close, we'll escort you to an exclusive
              viewpoint to witness Santorini's legendary sunset. Watch as the
              fading light bathes the whitewashed villages and azure waters in a
              golden glow, creating a truly magical atmosphere.
            </p>
            <p data-id="element-1557">
              Our tour concludes with a comfortable return journey to your
              accommodation, leaving you with memories to last a lifetime. With
              our expert local guides, small group size, and carefully curated
              itinerary, this tour offers the perfect blend of culture,
              gastronomy, and natural beauty.
            </p>
          </div>
          {!expanded && <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" data-id="element-1558"></div>}
        </div>
        <button onClick={() => setExpanded(!expanded)} className="mt-2 flex items-center text-blue-600 hover:text-blue-800 font-medium" data-id="element-1559">
          {expanded ? <>
              <span data-id="element-1560">Read less</span>
              <ChevronUpIcon size={18} className="ml-1" data-id="element-1561" />
            </> : <>
              <span data-id="element-1562">Read more</span>
              <ChevronDownIcon size={18} className="ml-1" data-id="element-1563" />
            </>}
        </button>
      </div>
    </section>;
}